import axiosInstance from "../../Lib/axios";
import {
  GET_FRANCHISE_FAILED, GET_FRANCHISE_SUCCESSFULLY,
  GET_USER_DETAIL_SUCCESSFULLY, GET_USER_DETAIL_FAILED,
  GET_USER_GROUP_SUCCESSFULLY, GET_USER_GROUP_FAILED, GET_NOTIFICATION_SUCCESSFULLY, GET_NOTIFICATION_FAILED,
  GET_USER_ROLES, GET_USER_ROLES_FAILED
} from "../types";

// get list of franchise
export const getFranchise = () => {
  let url = `/field-office/?ordering=name`;
  return (dispatch) => {
    return axiosInstance
      .get(url)
      .then((response) => {
        dispatch({
          type: GET_FRANCHISE_SUCCESSFULLY,
          data: response.data,
        });

      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error.response) {
          dispatch({
            type: GET_FRANCHISE_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// get user of detail
export const getUserDetail = (id) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/staff-user/${id}/`)
      .then((response) => {
        dispatch({
          type: GET_USER_DETAIL_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_USER_DETAIL_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// get user of group
export const getUserGroup = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/user-group/`, {params})
      .then((response) => {
        dispatch({
          type: GET_USER_GROUP_SUCCESSFULLY,
          data: response.data,
        });

      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_USER_GROUP_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// update user detail
export const editUserDetail = (params, uuid, callback) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/crm/staff-user/${uuid}/`, params)
      .then(() => {
        callback && callback();
        // dispatch({
        //   type: GET_USER_DETAIL_SUCCESSFULLY,
        //   data: response.data,
        // });

      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_USER_DETAIL_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// get notifications
export const getNotification = () => {
  return (dispatch) => {
    return axiosInstance
      .get(`/notification-preference/`)
      .then((response) => {
        dispatch({
          type: GET_NOTIFICATION_SUCCESSFULLY,
          data: response.data,
        });

      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_NOTIFICATION_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// update notifications
export const updateNotification = (params) => {
  return (dispatch) => {
    return axiosInstance
      .put(`/notification-preference/`, params)
      .then((response) => {
        dispatch({
          type: GET_NOTIFICATION_SUCCESSFULLY,
          data: response.data,
        });

      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_NOTIFICATION_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// get use roles
export const getUserRoles = () => {
  return (dispatch) => {
    return axiosInstance
      .get(`/role/`)
      .then((response) => {
        dispatch({
          type: GET_USER_ROLES,
          data: response.data,
        });

      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_USER_ROLES_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};